export default '/build/90be13e6.svg'